import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=5cc4be52&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=5cc4be52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4be52",
  null
  
)

export default component.exports